<template>
  <div>
    <vue-confirm-dialog class="custom-confirm-dialog"></vue-confirm-dialog>
    <admin-header :sectionTitle="sectionTitle"/>

    <admin-sidebar :can="$page.props.can" />

    <main id="content" role="main" class="main">
      <div class="content container-fluid">
        <slot :can="$page.props.can"></slot>
      </div>

      <admin-footer />
    </main>
  </div>
</template>

<script>
import AdminHeader from "@/Layouts/Partials/AdminHeader";
import AdminSidebar from "@/Layouts/Partials/AdminSidebar";
import AdminFooter from "@/Layouts/Partials/AdminFooter";

export default {
  components: {
    AdminHeader,
    AdminSidebar,
    AdminFooter,
  },

  props: ['sectionTitle'],
};
</script>

<style lang="scss">
.custom-confirm-dialog {
  .vc-btn {
    color: var(--primary);
  }
}
</style>
